import {api} from "./api.service";

export const CoachingClientLisitng = async (id, param) => {
  let res = await api.get(`coachingClients/get-clients/${id}`, {
    params: param,
  });
  return res;
};
export const CoachingClientById = async (id) => {
  let res = await api.get(`coachingClients/get-client-by-id/${id}`);
  return res;
};

export const GetCoachSessions = async (param) => {
  let res = await api.get("coachingSessions", { params: param });
  return res;
};
export const CreateCoachSessions = async (data, id) => {
  let res = await api.post(`coachingSessions`, data);
  return res;
};
export const EditCoachSessions = async (data, id) => {
  let res = await api.post(`coachingSessions/${id}`, data);
  return res;
};

export const EditClientCoachNote = async (payload) => {
  let res = await api.patch(`coachingClients/update-coach-notes`, payload);
  return res;
};

export const EditClientActionItems = async (payload) => {
  let res = await api.patch(`coachingClients/update-action-items`, payload);
  return res;
};

export const EditClientWinsItems = async (payload) => {
  let res = await api.patch(`coachingClients//update-client-wins`, payload);
  return res;
};

export const GetSingleCoachSessions = async (id) => {
  let res = await api.get(`coachingSessions/${id}`,);
  return res;
};

export const UpdateAnniversary = async (data) => {
  let res = await api.patch("coachingSessions/update-anniversary", data);
  return res;
};

